export const HELP = 'GENERAL_HELP_LINK';
export const TERMS_LINK_EN =
  'https://www.friendlyway.com/privacy-and-responsibility';
export const TERMS_LINK_DE =
  'https://www.friendlyway.de/impressum-und-datenschutz';

export const CHECKIN_NOTIFICATION_HELP = 'CHECKIN_NOTIFICATION_HELP_LINK';
export const CHECKIN_BADGE_HELP = 'CHECKIN_BADGE_HELP_LINK';
export const CHECKIN_PASS_HELP = 'CHECKIN_PASS_HELP_LINK';

export const PARKING_NOTIFICATION_HELP = 'PARKING_NOTIFICATION_HELP_LINK';
